import "./antd-override.scss";
import "./vyneThemeBase.scss";
import { App, ConfigProvider } from "antd";
import { VyneTheme } from "./vyneThemeConfig";
import { extend } from "dayjs";
import { useRef } from "react";
import utc from "dayjs/plugin/utc";

// --------------------------------------------------------------------------------------
//
//  Config Setup
//
// --------------------------------------------------------------------------------------

// Set up config for dayJS in ANTD to return UTC
extend(utc);

// --------------------------------------------------------------------------------------
//
//  Props
//
// --------------------------------------------------------------------------------------

interface VyneANTDProviderProps extends Readonly<React.PropsWithChildren> {
    readonly testMode?: boolean;
}

// --------------------------------------------------------------------------------------
//
//  Sub Providers
//
// --------------------------------------------------------------------------------------

const VyneANTDThemeProvider = ({ testMode = false, children }: Readonly<VyneANTDProviderProps>) => {
    const configRef = useRef<HTMLDivElement>(null);

    return (
        <ConfigProvider
            theme={{ ...VyneTheme, token: { ...VyneTheme.token, motion: !testMode } }}
            getPopupContainer={() => configRef.current ?? document.body}
        >
            <div ref={configRef} className="popup-container">
                {children}
            </div>
        </ConfigProvider>
    );
};

const VyneANTDAppProvider = ({ children }: Readonly<React.PropsWithChildren>) => (
    <App
        message={{
            maxCount: 1,
            duration: 3,
        }}
        notification={{
            maxCount: 1,
            duration: 4.5,
        }}
    >
        {children}
    </App>
);

// --------------------------------------------------------------------------------------
//
//  Providers
//
// --------------------------------------------------------------------------------------

export const VyneANTDProvider = ({ children, testMode = false }: Readonly<VyneANTDProviderProps>) => (
    <VyneANTDThemeProvider testMode={testMode}>
        <VyneANTDAppProvider>{children}</VyneANTDAppProvider>
    </VyneANTDThemeProvider>
);
